import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

export function useContactPersonMobile() {
  const { lang, selectedMandate } = useContext(PspContext);
  const navigate = useNavigate();
  const isTablet = useIsTablet();

  const noContact = !(
    selectedMandate?.buchhalter ||
    selectedMandate?.beraterBuchhaltung ||
    selectedMandate?.beraterLoehne ||
    selectedMandate?.lohnBuchhalter ||
    selectedMandate?.filialeBuchhaltung ||
    selectedMandate?.filialeLoehne
  );

  return { lang, navigate, isTablet, noContact, selectedMandate };
}
